import React from 'react';

const Separator = () => (
  <div className="sp-separator">
    <div className="sp-separator__item" />
  </div>
);

export default Separator;
